import React, { useEffect, useState } from "react";
import axios from "axios";
import {
    Document,
    Page,
    Text,
    View,
    Image,
    StyleSheet,
} from "@react-pdf/renderer";
import logo from "./images/logo.png";

const styles = StyleSheet.create({
    table: {
        display: "table",
        width: "auto",
        borderStyle: "solid",
        borderColor: "#aaaaaa",
        borderWidth: 1,
        borderRightWidth: 0,
        borderBottomWidth: 0,
    },
    tableRow: {
        margin: "auto",
        flexDirection: "row",
    },
    tableHead: {
        margin: "auto",
        flexDirection: "row",
        backgroundColor: "#E5E5CB",
        height: "20px",
    },
    tableText: {
        margin: "auto",
        color: "#222222",
        fontSize: "10px",
        fontWeight: "700",
    },
    tableCol: {
        width: "100px",
        borderStyle: "solid",
        borderColor: "#aaaaaa",
        borderWidth: 1,
        borderLeftWidth: 0,
        borderTopWidth: 0,
    },
    serial: {
        width: "30px",
        borderStyle: "solid",
        borderColor: "#aaaaaa",
        borderWidth: 1,
        borderLeftWidth: 0,
        borderTopWidth: 0,
    },
    tableCell: {
        margin: "auto",
        marginTop: 3,
        marginBottom: 3,
        fontSize: 8,
    },
    row: {
        flexDirection: "row",
        borderBottomColor: "#3778C2",
        borderBottomWidth: 1,
        alignItems: "center",
        height: 15,
        fontSize: 10,
        fontStyle: "bold",
        backgroundColor: "#aaaaaa",
    },
    titleContainer: {
        marginTop: 12,
    },
    reportTitle: {
        fontSize: 12,
        textAlign: "center",
        textTransform: "uppercase",
    },
    header: {
        marginTop: 15,
        marginBottom: 10,
    },
    APItitle: {
        color: "#035481",
        fontSize: 16,
        marginBottom: "5px",
        textAlign: "center",
        textTransform: "uppercase",
    },
    addressPhone: {
        color: "#222222",
        fontSize: 9,
        textAlign: "center",
        marginBottom: "2px",
    },
    jiaur: {
        paddingRight: "34px",
        paddingLeft: "30px",
    },
    logo: {
        width: 65,
        height: "auto",
        marginLeft: "auto",
        marginRight: "auto",
        marginBottom: "5px",
    },
});

function MyDocument() {
    const [manageDepartment, setManageDepartment] = useState([]);
    useEffect(() => {
        fetchDepartment();
    }, []);
    const fetchDepartment = async () => {
        await axios
            .get(
              process.env.REACT_APP_API + "/departments/APILimited"
            )
            .then(({ data }) => {
                setManageDepartment(data);
            });
    };
    return (
        <Document>
            <Page style={styles.body}>
                <View style={styles.jiaur}>
                    <View style={styles.header}>
                        <Image style={styles.logo} src={logo} />
                        <Text style={styles.APItitle}>
                            Advanced Project Integration Ltd.
                        </Text>
                        <Text style={styles.addressPhone}>
                            Address: House -4 Road 23/A Block B Banani Dhaka
                            1213 Bangladesh{" "}
                        </Text>
                        <Text style={styles.addressPhone}>
                            Phone: +88-02 55035911, E-mail: hello@api.net.bd
                        </Text>
                    </View>

                    <View style={styles.table}>
                        <View style={styles.tableHead}>
                            <View style={styles.serial}>
                                <Text style={styles.tableText}>SL</Text>
                            </View>
                            <View style={styles.tableCol}>
                                <Text style={styles.tableText}>Department</Text>
                            </View>
                            <View style={styles.tableCol}>
                                <Text style={styles.tableText}>
                                    Departments Details
                                </Text>
                            </View>
                        </View>

                        {manageDepartment.length > 0 &&
                            manageDepartment.map((row, key) => (
                                <View style={styles.tableRow} key={key}>
                                    <View style={styles.serial}>
                                        <Text style={styles.tableCell}>
                                            {key}
                                        </Text>
                                    </View>
                                    <View style={styles.tableCol}>
                                        <Text style={styles.tableCell}>
                                            {row.Department}
                                        </Text>
                                    </View>
                                    <View style={styles.tableCol}>
                                        <Text style={styles.tableCell}>
                                            {row.Departments_Details}
                                        </Text>
                                    </View>
                                </View>
                            ))}
                    </View>

                    <View style={styles.titleContainer}>
                        <Text style={styles.reportTitle}>
                            *** Thank You ***
                        </Text>
                    </View>
                </View>
            </Page>
        </Document>
    );
}
export default MyDocument;
